// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_1GBAsxV","gameDetails":"_1a0NLr8","dropdown":"_1X8fvuf","videoChatToggle":"_40f18G6"};